/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".logo[_ngcontent-%COMP%]{text-align:center}.logo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:300px;max-width:75%}.logo[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:21px}.form-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100%;height:40px;padding:15px}"];
export { styles as styles };
